import React from 'react';
import { Icon } from './Icon.js';
export const IconWindowFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m9.25.5H2.75C1.233.5,0,1.733,0,3.25v5.5c0,1.517,1.233,2.75,2.75,2.75h6.5c1.517,0,2.75-1.233,2.75-2.75V3.25c0-1.517-1.233-2.75-2.75-2.75Zm-6.75,3.5c-.552,0-1-.448-1-1s.448-1,1-1,1,.448,1,1-.448,1-1,1Zm3,0c-.552,0-1-.448-1-1s.448-1,1-1,1,.448,1,1-.448,1-1,1Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconWindowFill12.js.map